<template>
    <div>
        <a-drawer
            class="session-wrapper"
            :title="title"
            width="85%"
            placement="right"
            :closable="true"
            :body-style="{ height: 'calc(100vh - 57px)', paddingBottom: '50px', overflow: 'auto' }"
            :visible="visible"
            @close="handleCancelEvent"
        >
            <a-spin :spinning="loading">
                <div class="session-info">
                    <div class="flex x-left y-center">
                        <b class="mr25">{{ $t('program.batch_live_label_date' /* 日期 */) }}：{{ sessionInfo.meeting_date }}</b>
                        <b class="mr25">{{ $t('program.batch_live_label_hall' /* 会场 */) }}：{{ sessionInfo.meeting_hall }}</b>
                        <b class="mr25">{{ $t('program.batch_live_label_xuezu' /* 专题分论坛 */) }}：{{ sessionInfo.class_cnname }}</b>
                        <a-button class="mr10" size="small" type="primary" @click="$refs.sessionUpdateDrawerRef.show(sessionInfo)" v-if="!isSub">
                            {{ $t('program.edit_session' /* 编辑Session */) }}
                        </a-button>
                        <a-button size="small" type="primary" @click="$refs.batchAddProgramModalRef.show(sessionInfo)" v-if="!isSub">
                            {{ $t('program.batch_add_program_by_abstract_ids' /* 根据论文编号批量添加日程 */) }}
                        </a-button>
                    </div>
                    <div class="session-time flex x-left y-center">
                        <b class="mr25">{{ sessionInfo.starttime_slot }} ~ {{ sessionInfo.endtime_slot }}</b>
                        <span>{{ sessionInfo.abstract_title }} / {{ sessionInfo.abstract_title_en }}</span>
                    </div>
                </div>
                <div class="mt15">
                    <a-space v-if="!isSub">
                        <a-button type="primary" ghost icon="plus" @click="$refs.addCnTaskDrawerRef.show({ id: sessionInfo.id, lang: 'cn', type: 3 /* 主持类 */ })">
                            {{ $t('program.add_chair_host_translator_chinese' /* 添加主席/主持/翻译（中宾） */) }}
                        </a-button>
                        <a-button type="primary" ghost icon="plus" @click="$refs.addCnTaskDrawerRef.show({ id: sessionInfo.id, lang: 'en', type: 3 })">
                            {{ $t('program.add_chair_host_translator_foreign' /* 添加主席/主持/翻译（外宾） */) }}
                        </a-button>
                    </a-space>
                </div>
                <!-- 主持 -->
                <div class="mt10 flex x-left y-top" v-for="(duty, dIndex) in sessionInfo.duty_list" :key="dIndex">
                    <div class="mt5" style="line-height: 24px">{{ typeNameList[dIndex] }}：</div>
                    <a-button
                        class="mt5"
                        type="dashed"
                        size="small"
                        icon="plus"
                        @click="$refs.addCnTaskDrawerRef.show({ id: sessionInfo.id, lang: 'cn', type: 3, type_id: duty.type_id })"
                        v-if="!isSub"
                    >
                        {{ $t('program.chinese_guest' /* 中宾 */) }}
                    </a-button>
                    <a-button
                        class="ml10 mt5"
                        type="dashed"
                        size="small"
                        icon="plus"
                        @click="$refs.addCnTaskDrawerRef.show({ id: sessionInfo.id, lang: 'en', type: 3, type_id: duty.type_id })"
                        v-if="!isSub"
                    >
                        {{ $t('program.foreign_guest' /* 外宾 */) }}
                    </a-button>
                    <div class="flex-item flex flex-wrap x-left duty-list-container" :data-record-id="duty.type_id">
                        <div
                            v-for="(item, index) in duty['duty_list']"
                            :key="index"
                            class="duty-box role-duty-box"
                            draggable="true"
                            @dragstart="handleDutyDragStart($event, item, duty, index)"
                            @dragover="handleDutyDragOver($event)"
                            @dragenter="handleDutyDragEnter($event, index)"
                            @drop="handleDutyDrop($event, item, duty, index)"
                            @dragend="handleDutyDragEnd($event)"
                        >
                            <a-popover :title="false" placement="top">
                                <template slot="content">
                                    <a-icon
                                        class="fs18"
                                        style="padding: 5px; cursor: pointer"
                                        type="edit"
                                        @click="$refs.addCnTaskDrawerRef.show({ id: sessionInfo.id, duty_id: item.id, type: 3 })"
                                        v-if="!isSub"
                                    />
                                    <a-icon class="fs18" style="padding: 5px; cursor: pointer; color: #f00" type="delete" @click="handleDelete({ program_id: sessionInfo.id, duty_id: item.id })" />
                                </template>
                                <a-button style="min-width: 80px" size="small" class="ml10 mt5" @click="() => handleRepeatClick(duty['duty_list'][index])">
                                    {{ item.real_name }}
                                    <span class="color999 ml5 flex y-center" v-show="duty['duty_list'][index] && duty['duty_list'][index]['program_repeat']">
                                        <a-icon type="exclamation-circle" class="error-color fs12" theme="filled" />
                                        <span style="margin-left: 2px" class="fs12">{{ $t('program.view_conflict' /* 查看冲突 */) }}</span>
                                    </span>
                                </a-button>
                            </a-popover>
                        </div>
                    </div>
                </div>
                <div class="mt15 flex y-center x-between">
                    <a-checkbox v-model="isTimeCheckbox">{{ $t('program.time_linkage_checkbox' /* 当前条结束时间小于下一条的开始时间时，后面的时间段是否联动 */) }}</a-checkbox>
                    <a-space>
                        <a-button type="primary" icon="plus" @click="handleOpenAddTitleSpeakerEvent('', 'cn')">{{ $t('program.add_topic_speaker_chinese' /* 添加讲题讲者（中宾） */) }}</a-button>
                        <a-button type="primary" icon="plus" @click="handleOpenAddTitleSpeakerEvent('', 'en')">{{ $t('program.add_topic_speaker_foreign' /* 添加讲题讲者（外宾） */) }}</a-button>
                        <a-button type="primary" icon="plus" @click="handleOpenAddDiscussEvent('')" v-if="!isSub">{{ $t('program.add_discussion_etc' /* 添加讨论/辩论/其他 */) }}</a-button>
                    </a-space>
                </div>
                <!--   表格     -->
                <a-table
                    v-if="visible"
                    bordered
                    :rowKey="record => record.id"
                    :columns="columns"
                    :data-source="dataSource"
                    :custom-row="customRow"
                    :pagination="false"
                    class="mt15"
                    size="middle"
                    :defaultExpandAllRows="true"
                    :scroll="{ x: 1200 }"
                    :expand-icon-column-index="1"
                    :loading="tableLoading"
                >
                    <!-- eslint-disable-next-line vue/no-unused-vars -->
                    <template slot="drag" slot-scope="text, record">
                        <i class="medcon fs24 med-Drag drag-cell"></i>
                    </template>
                    <template slot="start_time" slot-scope="text, record, index">
                        <a-time-picker
                            style="width: 110px"
                            :placeholder="$t('program.start_time_placeholder' /* 开始时间 */)"
                            @change="handleTimeChange(record, index, 'start_time')"
                            v-model="record.starttime_slot"
                            format="HH:mm"
                        />
                    </template>
                    <template slot="end_time" slot-scope="text, record, index">
                        <a-time-picker
                            style="width: 110px"
                            :placeholder="$t('program.end_time_placeholder' /* 结束时间 */)"
                            @change="handleTimeChange(record, index, 'end_time')"
                            :disabledHours="() => disabledHours(record.starttime_slot)"
                            :disabledMinutes="(hours, minutes) => disabledMinutes(record.starttime_slot, hours, minutes)"
                            v-model="record.endtime_slot"
                            format="HH:mm"
                        />
                    </template>
                    <template slot="time_long" slot-scope="text, record, index">
                        <a-input-number style="width: 90px" step="1" :min="0" @change="handleTimeLongChange(record, index)" v-model="record.timelength" />
                    </template>
                    <template slot="abstract_title" slot-scope="text, record">
                        <div>ID:{{ record.id }} {{ record.abstract_title }}</div>
                        <div>{{ record.abstract_title_en }}</div>
                    </template>
                    <template slot="duty_list" slot-scope="text, record">
                        <template v-if="record.duty_list?.length">
                            <div class="duty-list-container" :data-record-id="record.id">
                                <div
                                    v-for="(duty, index) in record.duty_list"
                                    :key="index"
                                    class="duty-box"
                                    draggable="true"
                                    @dragstart="handleDutyDragStart($event, duty, record, index)"
                                    @dragover="handleDutyDragOver($event)"
                                    @dragenter="handleDutyDragEnter($event, index)"
                                    @drop="handleDutyDrop($event, duty, record, index)"
                                    @dragend="handleDutyDragEnd($event)"
                                >
                                    <a-popover :title="false" placement="top" v-if="duty.type == 3">
                                        <template slot="content">
                                            <a-icon
                                                class="fs18"
                                                style="padding: 5px; cursor: pointer"
                                                type="edit"
                                                @click="$refs.addCnTaskDrawerRef.show({ id: sessionInfo.id, program_id: record.id, duty_id: duty.id, type: 3 })"
                                            />
                                            <a-icon
                                                class="fs18"
                                                style="padding: 5px; cursor: pointer; color: #f00"
                                                type="delete"
                                                @click="handleDelete({ program_id: sessionInfo.id, duty_id: duty.id })"
                                            />
                                        </template>
                                        {{ duty.type == 3 ? `${duty.typename_cn}:` : '' }}
                                        {{ duty.real_name }} {{ duty.org_cnname }}
                                        <span class="color999 ml5 flex y-center x-center" @click="handleRepeatClick(duty)" v-show="duty.program_repeat">
                                            <a-icon type="exclamation-circle" class="error-color fs12" theme="filled" />
                                            <span style="margin-left: 2px" class="fs12">{{ $t('program.view_conflict' /* 查看冲突 */) }}</span>
                                        </span>
                                    </a-popover>
                                    <div v-else>
                                        {{ duty.type == 3 ? `${duty.typename_cn}:` : '' }}
                                        {{ duty.real_name }} {{ duty.org_cnname }}
                                        <span class="color999 ml5 flex y-center x-center" @click="handleRepeatClick(duty)" v-show="duty.program_repeat">
                                            <a-icon type="exclamation-circle" class="error-color fs12" theme="filled" />
                                            <span style="margin-left: 2px" class="fs12">{{ $t('program.view_conflict' /* 查看冲突 */) }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <div slot="action" slot-scope="text, record" class="flex x-between flex-wrap">
                        <a-button
                            size="small"
                            :style="{ width: $route.params.lang == 'cn' ? '49%' : '100%' }"
                            type="primary"
                            ghost
                            @click="$refs.addCnTaskDrawerRef.show({ id: sessionInfo.id, program_id: record.id, lang: 'cn', type: 3 })"
                        >
                            {{ $t('program.add_host_chinese' /* 添加主持（中宾） */) }}
                        </a-button>
                        <a-button
                            size="small"
                            :style="{ width: $route.params.lang == 'cn' ? '49%' : '100%', marginTop: $route.params.lang == 'cn' ? '0' : '10px' }"
                            type="primary"
                            ghost
                            @click="$refs.addCnTaskDrawerRef.show({ id: sessionInfo.id, program_id: record.id, lang: 'en', type: 3 })"
                        >
                            {{ $t('program.add_host_foreign' /* 添加主持（外宾） */) }}
                        </a-button>
                        <!-- 讨论类 -->
                        <template v-if="record.type == 4">
                            <a-button
                                @click="$refs.addCnTaskDrawerRef.show({ id: sessionInfo.id, lang: 'cn', type: record.type, program_id: record.id })"
                                class="mt10"
                                size="small"
                                :style="{ width: $route.params.lang == 'cn' ? '49%' : '100%' }"
                                type="primary"
                                ghost
                            >
                                {{ $t('program.add_task_cn' /* 添加任务（中宾） */) }}
                            </a-button>
                            <a-button
                                @click="$refs.addCnTaskDrawerRef.show({ id: sessionInfo.id, lang: 'en', type: record.type, program_id: record.id })"
                                class="mt10"
                                size="small"
                                :style="{ width: $route.params.lang == 'cn' ? '49%' : '100%' }"
                                type="primary"
                                ghost
                            >
                                {{ $t('program.add_task_en' /* 添加任务（外宾） */) }}
                            </a-button>
                            <a-button @click="handleAddSubTopic(record)" class="mt10" size="small" type="primary" :style="{ width: $route.params.lang == 'cn' ? '49%' : '100%' }" ghost>
                                {{ $t('program.add_sub_topic' /* 添加子讲题 */) }}
                            </a-button>
                        </template>
                        <a-button
                            class="mt10"
                            size="small"
                            :style="{ width: $route.params.lang == 'cn' ? '32%' : '100%' }"
                            type="primary"
                            ghost
                            @click="$refs.uploadRelatedVideoDrawerRef.show({ session_id: sessionInfo.id, ...record })"
                        >
                            {{ $t('program.upload_video' /* 上传视频 */) }}
                        </a-button>
                        <!-- 主持类 -->
                        <a-button
                            v-if="record.type != 4"
                            @click="handleOpenAddTitleSpeakerEvent(record.id, 'cn')"
                            class="mt10"
                            size="small"
                            :style="{ width: $route.params.lang == 'cn' ? '32%' : '49%' }"
                            type="primary"
                        >
                            {{ $t('program.edit' /* 编 辑 */) }}
                        </a-button>
                        <!-- 讨论类 -->
                        <a-button v-else @click="handleOpenAddDiscussEvent(record.id, 'cn')" class="mt10" size="small" :style="{ width: $route.params.lang == 'cn' ? '32%' : '49%' }" type="primary">
                            {{ $t('program.edit' /* 编 辑 */) }}
                        </a-button>
                        <a-button @click="handleDelProgramEvent(record.id)" class="mt10" size="small" :style="{ width: $route.params.lang == 'cn' ? '32%' : '49%' }" type="danger">
                            {{ $t('web.delete' /* 删除 */) }}
                        </a-button>
                    </div>
                </a-table>
            </a-spin>
            <div
                class="t-r"
                :style="{
                    position: 'absolute',
                    left: '0px',
                    bottom: '0px',
                    height: '50px',
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: '9999'
                }"
            >
                <a-button type="default" @click="handleCancelEvent">{{ $t('web.cancel' /* 取消 */) }}</a-button>
                <a-button class="ml10" type="primary" @click="handleSubmitEvent">{{ $t('program.batch_save' /* 批量保存 */) }}</a-button>
            </div>
        </a-drawer>
        <!-- 查看冲突任务列表 -->
        <repeat-duty-list-modal ref="repeatDutyListRef"></repeat-duty-list-modal>
        <!-- 编辑日程 -->
        <sessionUpdateDrawer
            :dateList="dateList"
            :hallList="hallList"
            :xuezuList="xuezuList"
            ref="sessionUpdateDrawerRef"
            @refresh="getSessionInfo"
            :title="$t('program.edit_session_drawer' /* 编辑日程 */)"
        />
        <!-- 添加中宾任务 -->
        <add-cn-task-drawer ref="addCnTaskDrawerRef" :dateList="dateList" :hallList="hallList" :sessionList="sessionList" @refresh="getSessionInfo" />
        <!-- 添加讲题讲者 -->
        <add-title-speaker ref="addTitleSpeakerRef" :isSub="isSub" :dateList="dateList" :hallList="hallList" :sessionList="sessionList" :sessionInfo="sessionInfo" @update="getSessionInfo" />
        <!-- 上传视频 -->
        <upload-related-video-drawer ref="uploadRelatedVideoDrawerRef" @refresh="getSessionInfo" />
        <!-- 添加讨讨论/辩论/其他 -->
        <add-discuss-drawer ref="addDiscussDrawerRef" :isSub="isSub" :dateList="dateList" :hallList="hallList" :sessionList="sessionList" :sessionInfo="sessionInfo" @update="getSessionInfo" />
        <!-- 批量添加论文日程 -->
        <batch-add-program-modal ref="batchAddProgramModalRef" @refresh="getSessionInfo" />
    </div>
</template>

<script>
import tableDrag from '@/utils/table.drag.mixins.js';
import moment from 'moment';
import repeatDutyListModal from './repeat-duty-list-modal.vue';
import sessionUpdateDrawer from './session-update-drawer.vue';
import addCnTaskDrawer from './add-cn-task-drawer.vue';
import addTitleSpeaker from './add-title-speaker.vue';
import uploadRelatedVideoDrawer from './upload-related-video-drawer.vue';
import addDiscussDrawer from './add-discuss-drawer.vue';
import batchAddProgramModal from './batch-add-program-modal.vue';

export default {
    name: 'childSessionDrawer',
    mixins: [tableDrag],
    components: {
        repeatDutyListModal,
        sessionUpdateDrawer,
        addCnTaskDrawer,
        addTitleSpeaker,
        uploadRelatedVideoDrawer,
        addDiscussDrawer,
        batchAddProgramModal
    },
    props: {
        xuezuList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        dateList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        hallList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        title: {
            type: String,
            default: ''
        },
        isSub: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            loading: false,
            isTimeCheckbox: true, // 当前条的结束时间小于开始时间时，后面的时间短是否联动
            dataSource: [],
            columns: [
                {
                    title: this.$t('program.sorting' /* 排序 */),
                    scopedSlots: { customRender: 'drag' },
                    width: 70,
                    align: 'center'
                    // fixed: 'left',
                },
                {
                    // fixed: 'left',
                    title: this.$t('program.time_period' /* 时间段 */),
                    dataIndex: 'starttime_slot',
                    children: [
                        {
                            title: this.$t('program.start_time' /* 开始时间 */),
                            scopedSlots: { customRender: 'start_time' },
                            width: 130,
                            align: 'center'
                        },
                        {
                            title: this.$t('program.end_time' /* 结束时间 */),
                            scopedSlots: { customRender: 'end_time' },
                            width: 130,
                            align: 'center'
                        }
                    ]
                },
                {
                    // fixed: 'left',
                    title: this.$t('program.duration_minutes' /* 时长（分钟） */),
                    scopedSlots: { customRender: 'time_long' },
                    align: 'center',
                    width: 110
                },
                {
                    title: this.$t('program.type' /* 类型 */),
                    dataIndex: 'typename_cn',
                    align: 'center'
                },
                {
                    title: this.$t('program.question' /* 题目 */),
                    dataIndex: 'abstract_title',
                    scopedSlots: { customRender: 'abstract_title' },
                    align: 'center'
                },
                {
                    title: this.$t('program.task_allocation' /* 任务分配 */),
                    dataIndex: 'duty_list',
                    scopedSlots: { customRender: 'duty_list' },
                    align: 'center'
                },
                {
                    title: this.$t('web.actions' /* 操作 */),
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    align: 'center',
                    width: 280,
                    fixed: 'right'
                }
            ],
            sessionInfo: {},
            typeNameList: [],
            sessionList: [],
            sessionId: '',
            // 拖拽相关状态
            dutyDragData: {
                sourceDuty: null,
                sourceRecord: null,
                sourceIndex: -1,
                targetIndex: -1
            },

            tableLoading: false,
            startTime: ''
        };
    },
    computed: {},
    methods: {
        show(data, sessionList) {
            console.log('data:', data);
            this.visible = true;
            // 优化sessionId的获取逻辑
            this.sessionId = this.getSessionId(data);
            this.sessionList = sessionList || [];
            this.getSessionInfo();
        },
        /**
         * 获取sessionId的优化方法
         * @param {Object} data - 传入的数据对象
         * @returns {string|number} sessionId
         */
        getSessionId(data) {
            // 优先使用id字段
            if (data.id) {
                return data.id;
            }

            // 检查parent_id是否存在且不为'0'
            if (data.parent_id && data.parent_id !== '0') {
                return data.parent_id;
            }

            // 最后使用program_id
            if (data.program_id) {
                return data.program_id;
            }
            return '';
        },
        // 添加讨论/辩论/其他
        handleOpenAddDiscussEvent(id, lang) {
            this.$refs.addDiscussDrawerRef.show(id, lang);
        },
        /**
         * 添加标题讲者
         * @param id 编辑数据 日程id
         */
        handleOpenAddTitleSpeakerEvent(id, lang) {
            this.$refs.addTitleSpeakerRef.show(id, lang);
        },
        // 删除日程
        handleDelProgramEvent(program_id) {
            this.$confirm({
                title: this.$t('web.tips' /* 温馨提示 */),
                content: this.$t('program.delete_program' /* 确认删除该日程吗？ */),
                onOk: () => {
                    this.$request.post({ url: 'delProgram', data: { program_id } }).then(res => {
                        this.$message.success(this.$t('web.delete_success' /* 删除成功 */));
                        this.getSessionInfo();
                    });
                }
            });
        },
        // 禁用时间
        disabledHours(start_time) {
            if (start_time) {
                let start_hour = start_time.hours();
                const hours = [];
                for (let i = 0; i < start_hour; i++) {
                    hours.push(i);
                }
                return hours;
            }
            return [];
        },
        // 禁用分钟
        disabledMinutes(start_time, hours, minutes) {
            if (start_time) {
                let start_hour = start_time.hours();
                if (hours > start_hour) {
                    return [];
                }
                let start_minutes = start_time.minutes();
                const minutes = [];
                for (let i = 0; i < start_minutes; i++) {
                    minutes.push(i);
                }
                return minutes;
            }
            return [];
        },
        /**
         * 递归设置其他时间段
         * # index 当前修改的时间索引
         * # endtime_slot 上一条的结束时间
         * # is_end_change 后续是否更着改变
         */
        setOtherTimeSlotFun(index, endtime_slot, is_end_change) {
            is_end_change = is_end_change || this.isTimeCheckbox;
            let currIndex = index + 1;
            if (this.dataSource.length > currIndex) {
                let it = this.dataSource[currIndex];
                // 判断时间是否在这个时间段内
                const isWithinTimeRange = endtime_slot.isBetween(it.starttime_slot, it.endtime_slot);
                // 是否大于结束时间
                const isLtEndTime = endtime_slot.isAfter(it.endtime_slot);
                if (isWithinTimeRange || isLtEndTime || is_end_change) {
                    let next_endtime_slot = moment(endtime_slot).add(it.timelength, 'minutes');
                    this.$set(this.dataSource[currIndex], 'starttime_slot', endtime_slot);
                    this.$set(this.dataSource[currIndex], 'endtime_slot', next_endtime_slot);
                    // 递归下一个session
                    this.setOtherTimeSlotFun(currIndex, next_endtime_slot);
                }
            }
        },
        /**
         * 时间段改变事件
         * @param item
         * @param index
         * @param type
         */
        handleTimeChange(item, index, type) {
            if (type == 'start_time') {
                let endtime_slot = moment(item.starttime_slot).add(item.timelength, 'minutes');
                this.$set(this.dataSource[index], 'endtime_slot', endtime_slot);
                if (index == 0) {
                    this.startTime = item.starttime_slot;
                }
            }
            if (type == 'end_time') {
                if (item.starttime_slot) {
                    var duration = moment.duration(item.endtime_slot.diff(item.starttime_slot));
                    // 获取相差的分钟数
                    var timelength = duration.asMinutes();
                    this.$set(this.dataSource[index], 'timelength', timelength);
                }
            }
            this.setOtherTimeSlotFun(index, item.endtime_slot);
        },
        /**
         * 时长改变事件
         * @param item
         * @param index
         */
        handleTimeLongChange(item, index) {
            if (item.starttime_slot) {
                let endtime_slot = moment(item.starttime_slot).add(item.timelength, 'minutes');
                this.$set(this.dataSource[index], 'endtime_slot', endtime_slot);
                this.setOtherTimeSlotFun(index, endtime_slot);
            }
        },
        /**
         * 批量保存
         */
        handleSubmitEvent() {
            const dataArr = [];
            this.dataSource.forEach(item => {
                dataArr.push({
                    id: item.id,
                    startTime: moment(item.starttime_slot).format('HH:mm'),
                    endTime: moment(item.endtime_slot).format('HH:mm'),
                    timeCount: item.timelength
                });
            });
            this.$request.post({ url: 'programOrderBy', data: { session_id: this.sessionId, dataArr } }).then(res => {
                const { code, message } = res;
                if (code == 200) {
                    this.$message.success(message);
                    this.$emit('refresh');
                    this.visible = false;
                } else {
                    this.$message.error(message);
                }
            });
        },
        /**
         * 获取session信息
         */
        getSessionInfo() {
            this.loading = true;
            this.$request
                .get({ url: 'getProgramSessionInfo', data: { session_id: this.sessionId } })
                .then(res => {
                    this.sessionInfo = res.data;
                    // 对program_list中的starttime_slot和endtime_slot进行moment格式化
                    if (Array.isArray(res.data.program_list)) {
                        this.startTime = res.data.program_list[0]?.starttime_slot || '';
                        res.data.program_list.forEach(item => {
                            if (item.starttime_slot) {
                                item.starttime_slot = moment(item.starttime_slot, 'HH:mm');
                            }
                            if (item.endtime_slot) {
                                item.endtime_slot = moment(item.endtime_slot, 'HH:mm');
                            }
                        });
                    }
                    this.dataSource = res.data.program_list;

                    this.formatDutyListFun(res.data.duty_list);
                    // 设置拖拽单元格事件
                    this.setupDragCell();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        /**
         * ## 格式化duty_list
         */
        formatDutyListFun(list) {
            this.typeNameList = [];
            list.forEach(item => {
                item.duty_list.forEach(dutyItem => {
                    this.typeNameList.push(dutyItem.typename_cn);
                });
            });
            // 对typeNameList去重
            this.typeNameList = Array.from(new Set(this.typeNameList));
        },
        /**
         * 点击冲突项
         */
        handleRepeatClick(data) {
            if (data.program_repeat) {
                // 存在重复
                this.$refs.repeatDutyListRef.show(data);
            }
        },
        /**
         * ## 删除任务
         */
        handleDelete(data) {
            this.$confirm({
                title: this.$t('web.tips' /* 温馨提示 */),
                content: this.$t('program.delete_task' /* 确认删除该任务吗？ */),
                onOk: () => {
                    this.$request.post({ url: 'delDuty', data }).then(res => {
                        this.$message.success(this.$t('web.delete_success' /* 删除成功 */));
                        this.getSessionInfo();
                    });
                }
            });
        },
        /**
         * 添加子讲题
         */
        handleAddSubTopic(record) {
            // 通过事件通知父组件打开新的子日程抽屉，保持当前抽屉打开
            this.$emit('open-sub-session', record, this.sessionList);
        },
        // 拖拽成功后调整时间槽逻辑
        dragSuccess({ sourceIndex, targetIndex }) {
            // 源索引大于目标索引：处理元素向前移动的情况
            if (sourceIndex > targetIndex) {
                this.handleSourceAfterTarget(sourceIndex, targetIndex);
            }
            // 目标索引大于源索引：处理元素向后移动的情况
            else if (targetIndex > sourceIndex) {
                this.handleSourceBeforeTarget(sourceIndex, targetIndex);
            }
        },

        /**
         * 处理源索引 > 目标索引的情况（元素向前移动）
         * @param {number} sourceIndex - 源位置索引
         * @param {number} targetIndex - 目标位置索引
         */
        handleSourceAfterTarget(sourceIndex, targetIndex) {
            // 获取目标位置下一个元素的开始时间（作为当前元素的新开始时间）
            const nextTargetStartTime = moment(this.dataSource[targetIndex + 1].starttime_slot, 'HH:mm');
            // 计算当前元素的新结束时间（开始时间 + 自身时长）
            const newEndTime = moment(nextTargetStartTime).add(this.dataSource[targetIndex].timelength, 'minutes');

            // 更新当前元素的时间槽
            this.setTimeSlot(targetIndex, nextTargetStartTime, newEndTime);

            // 调整后续元素的时间槽
            this.setOtherTimeSlotFun(targetIndex, newEndTime, true);
        },

        /**
         * 处理目标索引 > 源索引的情况（元素向后移动）
         * @param {number} sourceIndex - 源位置索引
         * @param {number} targetIndex - 目标位置索引
         */
        handleSourceBeforeTarget(sourceIndex, targetIndex) {
            // 计算当前元素的新开始时间：
            // - 若源索引是第一个元素，使用初始开始时间
            // - 否则使用前一个元素的结束时间
            const newStartTime = sourceIndex === 0 ? moment(this.startTime, 'HH:mm') : moment(this.dataSource[sourceIndex - 1].endtime_slot, 'HH:mm');

            // 计算当前元素的新结束时间（开始时间 + 自身时长）
            const newEndTime = moment(newStartTime).add(this.dataSource[sourceIndex].timelength, 'minutes');

            // 更新当前元素的时间槽
            this.setTimeSlot(sourceIndex, newStartTime, newEndTime);

            // 调整后续元素的时间槽
            this.setOtherTimeSlotFun(sourceIndex, newEndTime, true);
        },

        /**
         * 封装时间槽设置逻辑，避免重复调用this.$set
         * @param {number} index - 要更新的元素索引
         * @param {moment} startTime - 新的开始时间
         * @param {moment} endTime - 新的结束时间
         */
        setTimeSlot(index, startTime, endTime) {
            this.$set(this.dataSource[index], 'starttime_slot', startTime);
            this.$set(this.dataSource[index], 'endtime_slot', endTime);
        },

        /**
         * 开始拖拽duty
         */
        handleDutyDragStart(event, duty, record, index) {
            event.stopPropagation();
            this.dutyDragData.sourceDuty = duty;
            this.dutyDragData.sourceRecord = record;
            this.dutyDragData.sourceIndex = index;
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData(
                'text/plain',
                JSON.stringify({
                    dutyId: duty.id,
                    recordId: record.id || record.type_id,
                    index: index
                })
            );
        },
        /**
         * duty拖拽经过
         */
        handleDutyDragOver(event) {
            event.preventDefault();
            event.dataTransfer.dropEffect = 'move';
        },
        /**
         * duty拖拽进入目标
         */
        handleDutyDragEnter(event, index) {
            event.preventDefault();

            // 检查是否是同一个record内的拖拽
            const currentRecord = this.dutyDragData.sourceRecord;
            if (!currentRecord) return;

            // 获取当前拖拽目标所在的record
            const targetContainer = event.target.closest('.duty-list-container');
            if (!targetContainer) return;

            const targetRecordId = targetContainer.getAttribute('data-record-id');

            // 如果不是同一个record，不允许拖拽
            if (currentRecord.id !== parseInt(targetRecordId)) {
                event.dataTransfer.dropEffect = 'none';
                return;
            }

            this.dutyDragData.targetIndex = index;
            event.dataTransfer.dropEffect = 'move';

            // 添加拖拽目标高亮效果
            const dutyBoxes = targetContainer.querySelectorAll('.duty-box');
            dutyBoxes.forEach((box, i) => {
                if (i === index) {
                    box.classList.add('duty-drag-target');
                } else {
                    box.classList.remove('duty-drag-target');
                }
            });
        },
        /**
         * duty拖拽放置
         */
        handleDutyDrop(event, duty, record, index) {
            event.preventDefault();
            event.stopPropagation();

            // 清除拖拽高亮效果
            const dutyBoxes = event.target.closest('.duty-list-container').querySelectorAll('.duty-box');
            dutyBoxes.forEach(box => {
                box.classList.remove('duty-drag-target');
            });

            // 如果是同一个duty，不处理
            if (this.dutyDragData.sourceDuty && this.dutyDragData.sourceDuty.id === duty.id) {
                return;
            }

            // 检查是否是同一个record内的拖拽
            if (this.dutyDragData.sourceRecord && this.dutyDragData.sourceRecord.id === record.id) {
                // 同一record内的拖拽，允许重新排序
                this.handleDutyReorder(this.dutyDragData.sourceIndex, index, record);
            } else {
            }
        },
        /**
         * duty拖拽结束
         */
        handleDutyDragEnd(event) {
            // 清除拖拽高亮效果
            const dutyBoxes = document.querySelectorAll('.duty-box');
            dutyBoxes.forEach(box => {
                box.classList.remove('duty-drag-target');
            });

            // 重置拖拽数据
            this.dutyDragData = {
                sourceDuty: null,
                sourceRecord: null,
                sourceIndex: -1,
                targetIndex: -1
            };
        },
        /**
         * 处理duty重新排序（同一record内）
         */
        handleDutyReorder(sourceIndex, targetIndex, record) {
            if (sourceIndex === targetIndex) {
                return;
            }

            const dutyList = [...record.duty_list];
            const [movedDuty] = dutyList.splice(sourceIndex, 1);
            dutyList.splice(targetIndex, 0, movedDuty);

            // 更新数据
            this.$set(record, 'duty_list', dutyList);

            // 可以在这里调用API保存排序结果
            this.saveDutyOrder(dutyList);
        },

        /**
         * 保存duty排序
         */
        saveDutyOrder(dutyList) {
            // 这里可以调用API保存排序结果
            let cid = '';
            dutyList.forEach(item => {
                cid += item.id + ',';
            });
            cid = cid.slice(0, -1);
            this.tableLoading = true;
            this.$request
                .post({ url: 'programDutyOrderBy', data: { cid } })
                .then(res => {
                    const { code, message } = res;
                    if (code == 200) {
                        this.$message.success(message);
                        this.getSessionInfo();
                    } else {
                        this.$message.error(message);
                    }
                })
                .finally(() => {
                    this.tableLoading = false;
                });
        },
        handleCancelEvent() {
            this.visible = false;
            this.dataSource = [];
            this.dutyDragData = {};
            this.startTime = '';
            this.isTimeCheckbox = true;
        }
    },
    created() {},
    mounted() {
        // 设置拖拽配置，只在排序单元格内才能拖拽
        this.setDragConfig({
            dragOnlyInCell: true,
            dragCellClass: 'drag-cell'
        });
    }
};
</script>
<style lang="less" scoped>
.session-wrapper {
    /deep/.ant-btn > .anticon + span,
    /deep/.ant-btn > span + .anticon {
        margin-left: 2px;
    }
    /deep/.ant-btn-dashed {
        border-color: @theme;
        color: @theme;
    }

    // 拖拽相关样式
    /deep/.ant-table-row {
        transition: all 0.3s ease;

        &.target {
            background-color: #e6f7ff !important;
            border: 2px dashed #1890ff !important;
        }

        &.dragging {
            opacity: 0.5;
            transform: rotate(5deg);
        }
    }

    /deep/.drag-cell {
        cursor: move;
        user-select: none;

        &:hover {
            background-color: #f5f5f5;
        }
    }
}
.session-info {
    background-color: #fafafa;
    border: 1px solid #eee;
    border-radius: 3px;
    padding: 10px 15px;
    .session-time {
        padding-top: 10px;
        margin-top: 10px;
        border-top: 1px dashed #ddd;
    }
}
.duty-box {
    padding: 5px;
    border: 1px solid transparent;
    cursor: move;
    user-select: none;
    transition: all 0.3s ease;

    &:hover {
        border: 1px solid @theme;
        background-color: #f5f5f5;
    }

    &.duty-drag-target {
        background-color: #e6f7ff !important;
        border: 2px dashed #1890ff !important;
    }

    // 当拖拽到不同record时，显示禁用状态
    &.duty-drag-disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
}
.role-duty-box {
    padding: 0px;
    display: inline-block;
    border: none;
    &:hover {
        border: none;
    }
}
</style>
